import { render, staticRenderFns } from "./FormBuilder.vue?vue&type=template&id=7056d376"
import script from "./FormBuilder.vue?vue&type=script&lang=js"
export * from "./FormBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports